import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useInvalidatePrevSalesOrders, usePrevSalesOrders } from '@/hooks/api/1262_prev_sales_orders';
import { SalesOrderOutline } from '@/hooks/api/models';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { SalesOrderOutlineLogic } from '@/hooks/api/models/logics';
import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { useDestroyPrevSalesOrder } from '@/hooks/api/2650_destroy_prev_sales_order';
import { useLoading } from '@/providers/LoadingProvider';
import { useInvalidateTargetPrevSalesOrders } from '@/hooks/api/1265_target_prev_sales_orders';

export const PrevSalesOrdersElement = () => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const orderParams = { identifier: _w_!.identifier, team_id: _t_!.id, id: _so_!.id };
  const { data: prevOrders } = usePrevSalesOrders(orderParams);
  const { mutate, isSuccess, isPending } = useDestroyPrevSalesOrder();
  const { invalidate: invalidatePrevOrders } = useInvalidatePrevSalesOrders(orderParams);
  const { invalidate: invalidateTargetPrevOrders } = useInvalidateTargetPrevSalesOrders(orderParams);
  const [delTarget, setDelTarget] = useState<SalesOrderOutline>();

  useEffect(() => {
    if (isSuccess) {
      invalidatePrevOrders();
      invalidateTargetPrevOrders();
    }
  }, [isSuccess]);

  useEffect(() => setShowLoading(isPending), [isPending]);

  const onDeleteClick = () => {
    setShowLoading(true);
    mutate({ identifier: _w_!.identifier, team_id: _t_!.id, sales_order_id: _so_!.id, id: delTarget!.id });
  };

  if (prevOrders == null || prevOrders.length === 0) return null;

  return (
    <>
      <hr className="horizontal dark my-3" />

      <div className="table-responsive">
        <ModalConfirm
          modalId={`delConfirm`}
          okClicked={() => onDeleteClick()}
          message={'削除します。よろしいですか？'}
        />

        <table className="table align-items-center">
          <thead>
            <tr>
              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2">以前のプロジェクト</th>
              <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2" style={{ width: 60 }}></th>
            </tr>
          </thead>
          <tbody>
            {prevOrders?.map((d) => <PrevSalesOrderRow key={`prev-order-${d.id}`} d={d} setDelTarget={setDelTarget} />)}
          </tbody>
        </table>
      </div>
    </>
  );
};

type Props = {
  d: SalesOrderOutline;
  setDelTarget: Dispatch<SetStateAction<SalesOrderOutline | undefined>>;
};
const PrevSalesOrderRow = ({ d, setDelTarget }: Props) => {
  const orderLabel = useMemo(() => {
    return SalesOrderOutlineLogic.toLabel(d);
  }, [d]);

  return (
    <tr>
      <td className="font-weight-bold text-sm text-dark mb-1">{orderLabel}</td>
      <td>
        <button
          className="btn btn-icon-only bg-gradient-danger"
          data-bs-toggle="modal"
          data-bs-target={`#delConfirm`}
          onClick={() => setDelTarget(d)}
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </td>
    </tr>
  );
};
